import { Position, PokemonType } from "types/battle-engine/battle";
import { Pokemon } from "./pokemon";

export interface SkillCastTileConfig {
  position: Position;
  enemies: Pokemon[];
  allies: Pokemon[];
  healing: number;
  damage: number;
  type: PokemonType;
}

/**
 * Projectile class handles visual projectile rendering
 * - Non-directional sprite that rotates toward target
 * - Linear interpolation from start to end position
 * - Auto-destroys on completion
 * - Supports animated sprite strips (loops while flying)
 */
export class SkillCastTile {
  protected position: Position;
  protected isDestroyed: boolean = false;
  protected enemies: Pokemon[];
  protected allies: Pokemon[];
  protected healing: number;
  protected damage: number;
  protected type: PokemonType;

  constructor(config: SkillCastTileConfig) {
    this.position = config.position;
    this.enemies = config.enemies;
    this.allies = config.allies;
    this.healing = config.healing;
    this.damage = config.damage;
    this.type = config.type;
  }

  public fire(currentTick: number, resultHP?: number, targetId?: number) {}
}
